import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {MODULE, PageProps} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";
import EventExpando from "core/event/component/eventExpando";
import {loc} from "core/common/config/locales";

const gridLocation = 'eventHistoryList';

@observer
export default class EventList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = loc.i18n`Events`;
  static icon = 'commenting';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("EventList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gl => gridService.getOrCreateGrid(gridLocation));
  }

  render() {
    let {params, query} = this.props;
    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query} showExpand ExpandComponent={EventExpando} />
    );
  }

}



// WEBPACK FOOTER //
// ./src/core/event/eventList.tsx